import React from 'react';
import { useAppDispatch } from 'redux/store';

import { setNovoAIShowGenerateModal } from 'redux/actions/lecture-pages';
import GenerateButton from './generate-button';

const GenerateActivityButton = () => {
  const dispatch = useAppDispatch();

  const handleOpenModal = () => {
    dispatch(setNovoAIShowGenerateModal(true));
  };

  return (
    <GenerateButton
      onClick={handleOpenModal}
    />
  );
};

export default GenerateActivityButton;
